var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.34,
    height: 38.7,
    viewBox: "0 0 23.34 38.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    transform: "translate(-20.117 -12.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(20.267 12.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(9 3.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M245.133,42.667h-4.96a.992.992,0,1,0,0,1.92h4.96a.992.992,0,1,0,0-1.92Z",
    transform: "translate(-239.933 -42.667)",
    fill: "#0804b5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M121.6,0H106.24a3.845,3.845,0,0,0-3.84,3.84V34.56a3.845,3.845,0,0,0,3.84,3.84H121.6a3.845,3.845,0,0,0,3.84-3.84V3.84A3.845,3.845,0,0,0,121.6,0Zm1.92,34.56a1.92,1.92,0,0,1-1.92,1.92H106.24a1.92,1.92,0,0,1-1.92-1.92V3.84a1.92,1.92,0,0,1,1.92-1.92H121.6a1.92,1.92,0,0,1,1.92,1.92Z",
    transform: "translate(-102.4)",
    fill: "#0804b5",
    stroke: "#0804b5",
    strokeWidth: 0.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.b2c0afb43e47274191f7fb1d8d41bd15.svg";
export { ForwardRef as ReactComponent };